import { render, staticRenderFns } from "./AddSectionNotification.vue?vue&type=template&id=06a96b2c&scoped=true&"
import script from "./AddSectionNotification.vue?vue&type=script&lang=js&"
export * from "./AddSectionNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a96b2c",
  null
  
)

export default component.exports